import { Entity } from '../model/common';
import { ADGroupConfig } from './auth/ad-group.config';
import { BackofficeRole, BackofficeSsuPermission } from './auth/cc-backoffice-permission.config';

export const CURRENT_TERMS_VERSION = '2021-03-22';

export interface CCBackofficeUser {
  name: string;
  email: string;
  isSysAdmin: boolean;
}

export interface CCBackofficeUserInfo {
  sub: string; // Unique identifier
  name: string; // The displayed name
  email: string;

  oid: string;

  locale: string;
  roles: BackofficeRole[],
  ssus: BackofficeSsuPermission;
  adGroups: ADGroupConfig[];
  avatarUrl?: string;
  organizationId?: string;
  hdmCustomerNumber?: string;
}

export type CCBackofficeUserPublic = Omit<CCBackofficeUser, 'isSysAdmin'>;

export interface CCBackofficeUserConfirmation extends Entity {
  oid: string;
  name: string;
  email: string;
  createdAt: string;
  termsVersion: string;
  audits: CCBackofficeUserConfirmationAudit[];
}

export interface CCBackofficeUserConfirmationAudit {
  createdAt: string;
  termsVersion: string;
}

// for future use in post
export interface CCBackofficeUserConfirmationCreateParams { }
